import React from 'react';
import { Button, Modal } from 'antd';
import useHomeStore from '../../../../store/homeStore';

const SubscriptionExpiredModal = () => {
  const setShowSubscriptionExpiredModal = useHomeStore(
    (state) => state.setShowSubscriptionExpiredModal
  );
  const showSubscriptionExpiredModal = useHomeStore(
    (state) => state.showSubscriptionExpiredModal
  );

  return (
    <Modal
      title={showSubscriptionExpiredModal.header}
      open={showSubscriptionExpiredModal.status}
      onCancel={() =>
        setShowSubscriptionExpiredModal({
          message: '',
          header: '',
          status: false,
        })
      }
      footer={
        <Button
          onClick={() =>
            setShowSubscriptionExpiredModal({
              message: '',
              header: '',
              status: false,
            })
          }
        >
          Close
        </Button>
      }
    >
      <div>{showSubscriptionExpiredModal.message}</div>
    </Modal>
  );
};

export default SubscriptionExpiredModal;
